import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { StrictBase } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Observable } from 'rxjs';

export interface LocationSettings extends StrictBase {
  organizationalUnitId: string;
  railwaySidingsEnabled: boolean;
  googlePlacesEnabled: boolean;
  customLocationsEnabled: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LocationSettingsGateway {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'location-settings';

  public getLocationSettings(): Observable<LocationSettings> {
    return this.httpClient.get<LocationSettings>(
      `${this.config.host}/${this.path}`,
    );
  }

  public updateLocationSettings(
    id: string,
    settings: Partial<
      Pick<
        LocationSettings,
        | 'railwaySidingsEnabled'
        | 'googlePlacesEnabled'
        | 'customLocationsEnabled'
      >
    >,
  ): Observable<LocationSettings> {
    return this.httpClient.patch<LocationSettings>(
      `${this.config.host}/${this.path}/${id}`,
      settings,
    );
  }
}
